(function(){
  var p=new URLSearchParams(window.location.search);
  if(p.get('cart_open')!=='1') return;
  history.replaceState(null,'',window.location.pathname);
  
  function openUpCart(){
    // UpCart uses Shadow DOM — need to access via upcartDocumentOrShadowRoot
    var root=window.upcartDocumentOrShadowRoot;
    
    // Method 1: Add the class that UpCart uses to show the popup
    document.body.classList.add('upcartPopupShow');
    if(root){
      var popup=root.querySelector('#UpcartPopup');
      if(popup){
        popup.classList.add('upcart-popup-show');
        popup.style.display='';
      }
    }
    
    // Method 2: Simulate a cart icon click (most reliable - triggers UpCart's own open logic)
    var cartIcon=document.querySelector('#cart-icon-bubble, a[href="/cart"], .cart-icon-bubble, [data-cart-toggle]');
    if(cartIcon){
      cartIcon.click();
      return;
    }
    
    // Method 3: Dispatch the cart:refresh event that UpCart listens to
    window.dispatchEvent(new CustomEvent('upcart:open'));
  }
  
  // Wait for UpCart to initialize
  function tryOpen(){
    if(window.upcartDocumentOrShadowRoot){
      setTimeout(openUpCart, 300);
    } else {
      // UpCart not ready yet, retry
      setTimeout(tryOpen, 500);
    }
  }
  
  if(document.readyState==='complete') tryOpen();
  else window.addEventListener('load', tryOpen);
})();
